import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
// import Register from "../views/Register.vue";
import ForgotPassword from '../views/ForgotPassword.vue'
import Profile from '../views/Profile.vue'
import Companies from '../views/Companies.vue'
import NotFound from '../views/NotFound.vue'
import Vehicles from '../views/Vehicles'
import VehicleBatch from '../views/VehicleBatch'
import FinancialBatch from '../views/FinancialBatch'
import VehicleBatchDetail from '../views/VehicleBatchDetail'
import FinancialBatchDetail from '../views/FinancialBatchDetail'
import Millages from '../views/Millages'
import Locations from '../views/Locations'
import VehicleAdvanced from '../views/VehicleAdvanced'
import Calculator from '../views/Calculator'
import DimishedValueCalculator from '../views/DimishedValueCalculator'
import OperationReports from '../views/OperationReports'
import ReportAnalysis from '../views/ReportAnalysis'
import Tags from '../views/Tags'
import FutureValue from '../views/FutureValue'
import SummaryCurrent from '../views/SummaryCurrent'
import SummaryFuture from '../views/SummaryFuture'
import DemoAccount from '../views/DemoAccount'
import ProjectedRevLoss from '../views/ProjectedRevLoss'
import History from '../views/History'
import HistoricalTrend from '../views/HistoricalTrend'
import AccidentReport from '../views/AccidentReport'
import ZubieRoot from '../views/ZubieRoot'
import Help from '../views/Help'
import Demo from '../views/Demo'
import axios from '../axios'
import store from '../store'
import ZubieLogin from '@/views/ZubieLogin'
import ManheimBatch from '@/views/ManheimBatch'
import ManheimSearch from '@/views/ManheimSearch'
import ManheimBatchDetail from '@/views/ManheimBatchDetail'
import Invoices from '@/views/Invoices.vue'
import Invoice from '@/views/Invoice.vue'
import PriceAlerts from "@/views/PriceAlerts.vue";
import TsdAccount from '@/views/TsdAccount.vue'
import ResetPassword from "@/views/ResetPassword.vue";
import Groups from "@/views/Groups.vue";
import Classes from "@/views/Classes.vue";
import ClassPerformanceBatch from "@/views/ClassPerformanceBatch.vue";
import ClassPerformanceBatchDetail from "@/views/ClassPerformanceBatchDetail.vue";
import VehicleClassPerformance from "@/views/VehicleClassPerformance.vue";
import DepreciationOverrides from "@/views/DepreciationOverrides.vue";
import ForSale from "@/views/ForSale.vue";
import Blackbook from "@/views/Blackbook.vue";
import BlackbookShow from "@/views/BlackbookShow.vue";
import BlackbookList from "@/views/BlackbookList.vue";
import SocialAccounts from "@/views/SocialAccounts.vue";
import Oauth2Redirect from "@/views/Oauth2Redirect.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login-tsd',
      name: 'login',
      component: Login
    },
    // {
    //   path: "/register",
    //   name: "register",
    //   component: Register,
    // },
    {
      path: '/demo-account-request/:id',
      name: 'DemoAccount',
      component: DemoAccount
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password/:token',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter(to, from, next) {
        axios
          .get('me')
          .then(res => {
            !store.state.profile.user.id ? store.commit('profile/SET_USER', res.data.data) : ''
          })
          .finally(f => {
            next()
          })
      }
    },
    {
      path: '/manheim-search',
      name: 'manheim-search',
      component: ManheimSearch
    },
    {
      path: '/manheim-batch',
      name: 'manheim-batch',
      component: ManheimBatch
    },
    {
      path: '/manheim-batch/:id',
      name: 'manheim-batch-detail',
      component: ManheimBatchDetail
    },
    {
      path: '/historical-trend',
      name: 'historical-trend',
      component: HistoricalTrend
    },
    {
      path: '/reports',
      name: 'reports',
      component: History
    },
    {
      path: '/zubie/login',
      name: 'zubie-login',
      component: ZubieLogin
    },
    {
      path: '/tsd-account',
      name: 'tsd-account',
      component: TsdAccount
    },
    {
      path: '/zubie/callback',
      name: 'zubie-callback',
      component: ZubieRoot
    },
    {
      path: '/companies',
      name: 'companies',
      component: Companies
    },
    {
      path: '/groups/:companyId',
      name: 'groups',
      component: Groups
    },
    {
      path: '/classes/:companyId/:groupId',
      name: 'classes',
      component: Classes
    },
    {
      path: '/summary-future',
      name: 'summary-future',
      component: SummaryFuture
    },
    {
      path: '/summary-current',
      name: 'summary-current',
      component: SummaryCurrent
    },
    {
      path: '/company/:id',
      name: 'locations',
      component: Locations
    },
    {
      path: '/vehicles',
      name: 'vehicles',
      component: Vehicles
    },
    {
      path: '/vehicles/batch',
      name: 'vehicles-batch',
      component: VehicleBatch
    },
    {
      path: '/vehicles/batch/:id',
      name: 'vehicles-batch-detail',
      component: VehicleBatchDetail
    },
    {
      path: '/vehicles/financial-batch',
      name: 'financial-batch',
      component: FinancialBatch
    },
    {
      path: '/vehicles/financial-batch/:id',
      name: 'financial-batch-detail',
      component: FinancialBatchDetail
    },
    {
      path: '/class-performances/batch',
      name: 'class-performances-batch',
      component: ClassPerformanceBatch
    },
    {
      path: '/class-performances/batch/:id',
      name: 'class-performances-batch-detail',
      component: ClassPerformanceBatchDetail
    },
    {
      path: '/mileage',
      name: 'mileage',
      component: Millages
    },
    {
      path: '/demo',
      name: 'free-trial',
      component: Demo
    },
    /*
    {
      path: '/vehicle-advanced',
      name: 'vehicle-advanced',
      component: VehicleAdvanced
    },
    */
    {
      path: '/vehicle-class-performance',
      name: 'vehicle-class-performance',
      component: VehicleClassPerformance
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator
    },
    {
      path: '/tags',
      name: 'tags',
      component: Tags
    },
    {
      path: '/dimished-value-calculator',
      name: 'dimished-value-calculator',
      component: DimishedValueCalculator
    },
    {
      path: '/operation-reports',
      component: OperationReports,
      name: 'operation-reports',
      children: [
        {
          path: ':id',
          component: ReportAnalysis
        }
      ]
    },
    {
      path: '/future-value',
      name: 'future-value',
      component: FutureValue
    },
    {
      path: '/projected-rev-loss',
      name: 'projected-rev-loss',
      component: ProjectedRevLoss
    },
    {
      path: '/accident-report',
      name: 'accident',
      component: AccidentReport
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: Invoices
    },
    {
      path: '/invoice/:id',
      name: 'invoice',
      component: Invoice
    },
    {
      path: '/price-alerts',
      name: 'priceAlerts',
      component: PriceAlerts
    },
    {
      path: '/depreciation-overrides',
      name: 'depreciation-overrides',
      component: DepreciationOverrides
    },
    {
      path: '/for-sale',
      name: 'for-sale',
      component: ForSale
    },
    {
      path: '/vehicle-advanced',
      name: 'blackbook',
      component: Blackbook
    },
    {
      path: '/vehicle-advanced/list',
      name: 'blackbook_list',
      component: BlackbookList
    },
    {
      path: '/vehicle-advanced/:id',
      name: 'blackbook_show',
      component: BlackbookShow
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/social-accounts',
      name: 'social-accounts',
      component: SocialAccounts
    },
    {
      path: '/oauth2/:provider',
      name: 'oauth2-redirect',
      component: Oauth2Redirect
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
